import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import "../css/AdminCollections.css";
import { Modal, Button } from "react-bootstrap";
// import Card from "../components/card";
import Icon from "../util/Icon";
import * as API from "../services/API";
import ErrorModal from "../components/ErrorModal";
import SuccessToast from "../components/SuccessToast";
import Footer from "../components/Footer";


// Modal Component
const MyModal = ({ onClose,onAdd,evenement = null }) => {
	const [name, setName] = useState(evenement?evenement.name:null);
	const [logo, setLogo] = useState(evenement?evenement.logo:null);
	const [link, setLink] = useState(evenement?evenement.link:null);
	const [extension, setExtension] = useState("");
	const isValidLink = (value) => {
		try {
			const url = new URL(value);
			return url.protocol === "http:" || url.protocol === "https:";
		} catch {
			return false;
		}
	};
	const isFormComplete =
		Boolean(name?.trim()) &&
		Boolean(logo) &&
		Boolean(link?.trim()) &&
		isValidLink(link.trim());

	// const [description, setDescription] = useState("");
	return (
	<Modal
        show={true}
        onHide={onClose}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Création de partenaire
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
			<label htmlFor="name">Nom</label>
			<input
				type={"text" }
				className="form-control m-2"
				id="name"
				value={name}
				onChange={(e)=>setName(e.target.value)}
				name="name"
			/>
      <label htmlFor="link">Lien</label>
			<input
				type="url"
				className="form-control m-2"
				id="link"
				value={link || ""}
				onChange={(e)=>setLink(e.target.value)}
				name="link"
				placeholder="https://exemple.fr"
			/>
			{link?.trim() && !isValidLink(link.trim()) && (
				<div className="text-danger small ms-2">
					Le lien doit commencer par http:// ou https://
				</div>
			)}
  
			<div class="mb-3">
				<label for="formFile" class="form-label">Choisissez une image :</label>
				{logo !== null && <p for="formFile" class="form-label text-danger">Ajouter une image remplacera la précédente</p>}
				<input class={(logo !== null)?"form-control bg-success":"form-control"} type="file" id="formFile" onChange={(e)=>{
					const file = e.target.files[0];
					if (!file) return;
					setExtension(file.type.replace("image/",""));

					const reader = new FileReader();
					reader.onloadend = () => {
						setLogo(reader.result);
					};

					reader.readAsDataURL(file);
					}}/>
			</div>
			
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Annuler
          </Button>
		  <Button
			variant="primary"
			disabled={!isFormComplete}
			onClick={()=>onAdd({
				name: name.trim(),
				logo,
				link: link.trim(),
				extension
			})}
		  >
            Ajouter
          </Button>
        </Modal.Footer>
      </Modal>
    );
}	

function EvenementsAdmin(){
	const [modalOpen, setModalOpen] = useState(null);
	const [partnerList, setPartnerList] = useState([]);
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	useEffect(() => {
		API.getAllPartenairesRequest(
			(response)=>{
				setPartnerList(response.data);
			},
			()=>{
			}
			)
		},
		[]
		);
	const addEvenements = (data) => {API.createPartenaireRequest(data,()=>{API.getAllPartenairesRequest((response)=>{setPartnerList(response.data);setSuccess("Partenaire ajoute avec succes.");closeModal();},(data)=>{{};closeModal();})},(data)=>{setError(data);})};
	const openAddModal = () => setModalOpen(<MyModal onClose={closeModal} onAdd={addEvenements}/>);
	const openUpdateModal = (evenement) => setModalOpen(<MyModal onClose={closeModal} onAdd={addEvenements} evenement={evenement}/>);
	const closeModal = () => setModalOpen(null);
	let action = (a)=>(<>
					<button
					type="button"
					className="admin-icon-button"
					aria-label={`Modifier ${a.name}`}
					onClick={(e) =>
						openUpdateModal(a)
					}
					>
						<Icon icon="pen-to-square" />
					</button>
				<button
					type="button"
					className="admin-icon-button admin-icon-button-danger"
					aria-label={`Supprimer ${a.name}`}
					onClick={(e) =>{
						API.removePartenaireByIdRequest(a._id,()=>{API.getAllPartenairesRequest(
							(response)=>{
								setPartnerList(response.data);
							},
							()=>{
							}
							)
						},()=>{});
					}
					}
					>
						<Icon icon="trash" />
					</button>
				</>);


return (
  <>
    <div className="admin-collection-page">
      <HeaderHomeAdmin />

      <main className="container py-5">
        <section className="admin-collection-hero">
          <div>
            <span className="admin-collection-eyebrow">Réseau de l'association</span>
            <h1>Nos partenaires</h1>
            <p>Gérez les organismes affichés sur le site et leurs liens.</p>
          </div>
          <div className="admin-collection-actions">
            <div className="admin-collection-count" aria-label={`${partnerList.length} partenaires`}>
              <strong>{partnerList.length}</strong>
              <span>{partnerList.length > 1 ? "partenaires" : "partenaire"}</span>
            </div>
            <button type="button" className="admin-primary-button" onClick={openAddModal}>
              <Icon icon="plus" />
              Créer un partenaire
            </button>
          </div>
        </section>

        {partnerList && partnerList.length > 0 ? (
          <div className="admin-collection-grid admin-partner-grid">
            {partnerList.map((evenement) => (
              <article className="admin-partner-card" key={evenement._id || evenement.id}>
                <div className="admin-partner-logo">
                  {evenement.image || evenement.logo ? (
                    <img src={evenement.image || evenement.logo} alt={`Logo de ${evenement.name}`} />
                  ) : (
                    <Icon icon="handshake" size="2xl" />
                  )}
                </div>
                <div className="admin-partner-content">
                  <span className="admin-person-label">Partenaire</span>
                  <h2>{evenement.name}</h2>
                  <a
                    href={evenement.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="admin-partner-link"
                  >
                    <Icon icon="arrow-up-right-from-square" />
                    <span>{evenement.link}</span>
                  </a>
                </div>
                <div className="admin-card-footer">
                  <span className="admin-card-footer-label">Actions</span>
                  <div className="admin-card-actions">{action(evenement)}</div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="admin-collection-empty">
            <span className="admin-collection-empty-icon">
              <Icon icon="handshake" size="2xl" />
            </span>
            <h2>Aucun partenaire disponible</h2>
            <p>Créez votre premier partenaire pour le faire apparaître ici.</p>
            <button type="button" className="admin-primary-button" onClick={openAddModal}>
              <Icon icon="plus" />
              Créer un partenaire
            </button>
          </div>
        )}

        {modalOpen}
        <ErrorModal
          show={!!error}
          message={error}
          onClose={() => setError(null)}
        />
        <SuccessToast
          show={!!success}
          message={success}
          onClose={() => setSuccess(null)}
        />
      </main>
    </div>
	<Footer/>
  </>
);
}


export default EvenementsAdmin;
